import { hotTickerItems } from "@/mocks/site";

const track = [...hotTickerItems, ...hotTickerItems];

export default function TickerBar() {
  return (
    <div className="hot-ticker w-full overflow-hidden border-b border-background-300/60 bg-primary-950">
      <div className="flex items-center">
        <div className="hidden sm:flex shrink-0 items-center gap-2 bg-primary-500 px-4 py-3 text-xs font-medium text-background-50">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-flashlight-fill" aria-hidden="true"></i>
          </span>
          滚动热点
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="hot-ticker-track flex w-max items-center">
            {track.map((text, index) => (
              <span
                key={`${text}-${index}`}
                className="flex items-center whitespace-nowrap px-6 py-3 text-xs text-background-100"
              >
                <span className="mr-3 w-1.5 h-1.5 rounded-full bg-accent-400" />
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}